import { createAction, props } from '@ngrx/store';
import { CustomManufacturerCampaignOverview, ManufacturerCampaignResultsData, ManufacturerCampaignSalesNotification } from '../custom-manufacturer-campaign.models';

export const getManufacturerCampaign = createAction(
    '[Custom Manufacturer Campaign] search Manufacturer Campaign',
    props<{
        productCode:string,
        manufacturerNumber:string,
        manufacturerId:string,
        ean:string,
        campaignId:string
        showOldData:boolean
    }>()
  );

export const getManufacturerCampaignSuccess = createAction(
    '[Custom Manufacturer Campaign] search Manufacturer Campaign success',
    props<{ manufacturercampaignOverview: CustomManufacturerCampaignOverview }>()
);

export const getManufacturerCampaignFailure = createAction(
    '[Custom Manufacturer Campaign] search Manufacturer Campaign failure',
    props<{ error: Error }>()
);

// *****************************************************

export const getManufacturerCampaignDetails = createAction(
    '[Custom Manufacturer Campaign] get manufacturer campaign details',
    props<{ 
        campaignId: string,
        productCode:string 
    }>()
);

export const getManufacturerCampaignDetailsSuccess = createAction(
    '[Custom Manufacturer Campaign] get manufacturer campaign details success',
    props<{ manufacturerCampaignDetails: ManufacturerCampaignSalesNotification[] }>()
);
  
export const getManufacturerCampaignDetailsFailure = createAction(
    '[Custom Manufacturer Campaign] get manufacturer campaign details failure',
    props<{ error: Error }>()
);

// *****************************************************

export const deleteSalesNotification = createAction(
    '[Custom Manufacturer Campaign] delete sales notification',
    props<{ salesNotificationPkList: string[]; }>()
);

export const deleteSalesNotificationSuccess = createAction(
    '[Custom Manufacturer Campaign] delete sales notification success'
);
  
export const deleteSalesNotificationFailure = createAction(
    '[Custom Manufacturer Campaign] delete sales notification failure'
);

export const deleteSalesNotificationReset = createAction(
    '[Custom Manufacturer Campaign] delete sales notification reset'
);

// *****************************************************

export const updateSalesNotification = createAction(
    '[Custom Manufacturer Campaign] update sales notification',
    props<{ salesNotifications: ManufacturerCampaignSalesNotification[] }>()
);

export const updateSalesNotificationSuccess = createAction(
    '[Custom Manufacturer Campaign] update sales notification success'
);
  
export const updateSalesNotificationFailure = createAction(
    '[Custom Manufacturer Campaign] update sales notification failure',
    props<{
        errorMessage:ManufacturerCampaignResultsData[]
    }>()
);

export const updateSalesNotificationReset = createAction(
    '[Custom Manufacturer Campaign] update sales notification reset'
);